Core.InvoicingRouter = Core.SubRouter.extend({
    routes: {
        'nocustomer': 'noCustomer',
        'not-invoiced': 'notInvoiced',
        'not/customer/:customerId': 'notInvoicedCustomer',
        'not/customerproject/:customerProjectId': 'notInvoicedCustomerProject',
        'not/customer/:customerId/activity/:activityId': 'notInvoicedCustomer',
        'not/customerproject/:customerProjectId/activity/:activityId': 'notInvoicedCustomerProject',
        'job/:jobId': 'job',
        'customer/:customerId': 'customer',
        'customerproject/:customerProjectId': 'customerProject',
        'customer/:customerId/activity/:activityId': 'customer',
        'customerproject/:customerProjectId/activity/:activityId': 'customerProject',
        'customer/:customerId/asset/:assetId': 'asset',
        'new': 'newInvoice',
        'finish': 'finishInvoices',
        ':id': 'viewInvoice',
        '': 'invoicing',
        '*path': 'invoicing',
    },

    noCustomer: function() {
        app.setMainView(new InvoiceNoCustomerView(), 'invoicing');
    },

    notInvoiced: function() {
        app.setMainView(new NotInvoicedView(), 'invoicing');
    },

    notInvoicedCustomer: function(customerId, activityId) {
        app.setMainView(new NotInvoicedView({customerId: parseInt(customerId), activityId: parseInt(activityId)}), 'invoicing');
    },

    notInvoicedCustomerProject: function(customerProjectId, activityId) {
        app.setMainView(new NotInvoicedView({customerProjectId: parseInt(customerProjectId), activityId: parseInt(activityId)}), 'invoicing');
    },

    job: function(jobId) {
        var view = new InvoicingView();
        view.fetchCandidatesForJob(jobId);
        app.setMainView(view, 'invoicing');
    },

    customer: function(customerId, activityId) {
        var view = new InvoicingView();
        view.fetchCandidatesForCustomer(customerId, activityId);
        app.setMainView(view, 'invoicing');
    },

    customerProject: function(customerProjectId, activityId) {
        var view = new InvoicingView();
        view.fetchCandidatesForCustomerProject(customerProjectId, activityId);
        app.setMainView(view, 'invoicing');
    },

    asset: function(customerId, assetId, activityId) {
        var view = new InvoicingView();
        view.fetchCandidatesForCustomerAndAsset(customerId, assetId, activityId);
        app.setMainView(view, 'invoicing');
    },

    newInvoice: function() {
        var existingView = app.view && app.view.invoices;
        if (!existingView) history.back();
        /* weird route for legacy reasons... providing route mainly for back button
        var view = app.view;
        if (!existingView) view = new InvoicingView();
        if ('invoices' in sessionStorage) {
            view.invoices.reset(JSON.parse(sessionStorage['invoices']));
        }
        if (!existingView) app.setMainView(view, 'invoicing');
        */
    },

    finishInvoices: function() {
        var existingView = app.view && app.view.invoices;
        if (!existingView) history.back();
        /* weird route for legacy reasons... providing route mainly for back button
        var view = app.view;
        if (!existingView) view = new InvoicingView();
        if ('invoicesToFinish' in sessionStorage) {
            view.invoices.reset(JSON.parse(sessionStorage['invoicesToFinish']));
        }
        if (!existingView) app.setMainView(view, 'invoicing');
        */
    },

    viewInvoice: function(id) {
        app.setMainView(new InvoiceView({
            model: new Invoice({id: id})
        }), 'invoicing');
    },

    invoicing: function() {
        app.setMainView(new InvoicingView(), 'invoicing');
    },

});
